<div class="space-y-4">
  <!-- centrar imagen -->
  <div class="flex justify-center items-center">
    @if (producto().url_imagen) {
      <img
        src="{{ producto().url_imagen }}"
        alt="{{ producto().nombre }}"
        class="w-48 h-48 object-cover rounded-lg"
      />
    } @else {
      <div
        class="w-48 h-48 bg-linear-to-br from-gray-100 to-gray-200 rounded-lg flex items-center justify-center"
      >
        <i class="bi bi-image text-4xl text-gray-400"></i>
      </div>
    }
  </div>
  <div class="grid grid-cols-2 gap-4">
    <div>
      <span class="block text-xs text-gray-500">Código</span>
      <span class="block text-base text-gray-800 font-semibold">{{ producto().codigo }}</span>
    </div>
    <div>
      <span class="block text-xs text-gray-500">Nombre</span>
      <span class="block text-base text-gray-800 font-semibold">{{ producto().nombre }}</span>
    </div>
    <div class="col-span-2">
      <span class="block text-xs text-gray-500">Descripción</span>
      <span class="block text-base text-gray-800">{{ producto().descripcion }}</span>
    </div>
    <div>
      <span class="block text-xs text-gray-500">Precio Venta</span>
      @if (
        producto().descuento_campana_id != null &&
        producto().precio_venta_final != null &&
        producto().precio_venta_original != null
      ) {
        <span class="block text-xs text-gray-400 line-through"
          >S/ {{ producto().precio_venta_original }}</span
        >
        <span class="block text-base text-blue-700 font-semibold"
          >S/ {{ producto().precio_venta_final }}</span
        >
      } @else {
        <span class="block text-base text-gray-800">S/ {{ producto().precio_venta }}</span>
      }
    </div>
    <div>
      <span class="block text-xs text-gray-500">Precio Base</span>
      <span class="block text-base text-gray-800">S/ {{ producto().precio_base }}</span>
    </div>
    <div>
      <span class="block text-xs text-gray-500">Unidad de Medida</span>
      <span class="block text-base text-gray-800">{{ producto().unidad_medida }}</span>
    </div>
    <div>
      <span class="block text-xs text-gray-500">Stock</span>
      <span class="block text-base text-gray-800">{{ producto().stock_sucursal.stock }}</span>
    </div>
    <div>
      <span class="block text-xs text-gray-500">Categoría</span>
      <span class="block text-base text-gray-800">{{
        producto().categoria?.nombre || 'Sin categoría'
      }}</span>
    </div>
    <div>
      <span class="block text-xs text-gray-500">Activo</span>
      <span class="block text-base text-gray-800">{{ producto().activo ? 'Sí' : 'No' }}</span>
    </div>
    <div>
      <span class="block text-xs text-gray-500">Controlar Stock</span>
      <span class="block text-base text-gray-800">{{
        producto().stock_sucursal.controlar_stock ? 'Sí' : 'No'
      }}</span>
    </div>
    <div>
      <span class="block text-xs text-gray-500">Es Servicio</span>
      <span class="block text-base text-gray-800">{{
        producto().producto_servicio ? 'Sí' : 'No'
      }}</span>
    </div>

    @if (producto().descuento_campana_id != null) {
      <div>
        <span class="block text-xs text-gray-500">Campaña de descuento</span>
        <span class="block text-base text-gray-800">#{{ producto().descuento_campana_id }}</span>
      </div>
      <div>
        <span class="block text-xs text-gray-500">Objetivo descuento</span>
        <span class="block text-base text-gray-800">{{
          producto().descuento_objetivo_tipo || '-'
        }}</span>
      </div>
      <div class="col-span-2">
        <span class="block text-xs text-gray-500">Valor aplicado</span>
        <span class="block text-base text-gray-800">{{
          producto().descuento_valor_aplicado ?? 0
        }}</span>
      </div>
    }
  </div>

  @if (producto().producto_servicio !== undefined) {
    <div class="border-t pt-4 mt-4">
      <span class="block text-xs text-gray-500 mb-2">Opciones de Servicio</span>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <span class="block text-xs text-gray-500">Gestionar por tiempo</span>
          <span class="block text-base text-gray-800">{{
            producto().producto_servicio?.es_gestion_tiempo ? 'Sí' : 'No'
          }}</span>
        </div>
        <div>
          <span class="block text-xs text-gray-500">Duración (minutos)</span>
          <span class="block text-base text-gray-800">{{
            producto().producto_servicio?.duracion_minutos
          }}</span>
        </div>
      </div>
    </div>
  }

  <div class="flex justify-end gap-2 pt-4">
    <button type="button" class="px-4 py-2 rounded bg-gray-200" (click)="onCerrar()">Cerrar</button>
  </div>
</div>
